// extracted by mini-css-extract-plugin
export default {"optionListWrapper":"optionListWrapper__1Ri7Q","optionList":"optionList__1oTIE","optionListMobileDetails":"optionListMobileDetails__8sJGv"};